import { canvasToPngBlob } from 'src/helpers/canvas.helper';
import { sanitize } from './report-file-name';

const QR_FILE_SUFFIX = 'check-in QR';
const QR_FILE_FALLBACK = 'event-check-in-qr';

export function buildQrFileName(eventTitle?: string): string {
  const clean = sanitize(eventTitle);
  const base = clean ? `${clean} - ${QR_FILE_SUFFIX}` : QR_FILE_FALLBACK;
  return `${base}.png`;
}

function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error('Failed to load the QR SVG as an image'));
    image.src = src;
  });
}

interface SvgToPngBlobParams {
  markup: string;
  size: number;
  margin: number;
}

export async function svgToPngBlob({ markup, size, margin }: SvgToPngBlobParams): Promise<Blob> {
  const svgUrl = URL.createObjectURL(new Blob([markup], { type: 'image/svg+xml;charset=utf-8' }));
  try {
    const image = await loadImage(svgUrl);
    const canvas = document.createElement('canvas');
    canvas.width = size + margin * 2;
    canvas.height = size + margin * 2;
    const context = canvas.getContext('2d');
    if (!context) throw new Error('Canvas 2D context is unavailable');
    context.fillStyle = '#FFFFFF';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.drawImage(image, margin, margin, size, size);
    return await canvasToPngBlob(canvas);
  } finally {
    URL.revokeObjectURL(svgUrl);
  }
}
